import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

export default function setTopBar() {
  const topBar = document.querySelector("[data-top-bar]");
  if (!topBar) return

  const slides = topBar.querySelectorAll('.swiper-slide');
  const hasMultipleSlides = slides.length > 1;

  const topBarSwiper = new Swiper(topBar.querySelector('.swiper'), {
    modules: [Autoplay, EffectFade],
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    loop: hasMultipleSlides,
    speed: 700,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: hasMultipleSlides,
    autoplay: hasMultipleSlides ? {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    } : false,
  });

  // Autoplay
  if (!hasMultipleSlides || !topBarSwiper.autoplay) return;

  topBarSwiper.autoplay.stop();
  const eventType = window.mobile ? 'scroll' : 'mousemove';
  window.addEventListener(eventType, () => topBarSwiper.autoplay.start(), { once: true });
}
